import Skeleton from '@/global/components/Skeleton'
import ContentGuide from 'global/guides/ContentGuide'
import React from 'react'

export const PreLoading: React.FC = () => {
    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['']}>
                    <Skeleton className="h-15 w-150 max-w-full flex-grow-0" />
                </ContentGuide.Header>
                <div className="w-full h-full flex justify-center items-center">
                    <Skeleton />
                </div>
            </ContentGuide.Card>
        </ContentGuide>
    )
}
